import { defineStore } from 'pinia';
import { LocalStorage } from 'quasar';
import UserService from 'src/core/services/UserService';
import { ref } from 'vue';

export const AuthStore = defineStore('AuthStore', {
  state(): { token: string | null; user: { email: string | null; username: string | null; name: string | null; avatar: string | null } } {
    return {
      token: process.env.CLIENT ? LocalStorage.getItem('user-token') || null : null,
      user: {
        email: null,
        username: null,
        name: null,
        avatar: null,
      },
    };
  },
  getters: {
    isLogged: (state) => !!state.token,
    me: (state) => state.user,
  },
  actions: {
    register(userData: { nameSurname: string; email: string; password: string; passwordAgain: string; birthday: string }) {
      return new Promise((resolve, reject) => {
        UserService.userRegister(userData)
          .then((res) => {
            if (res.status._200_) {
              LocalStorage.set('user-token', res.data.token);

              this.token = res.data.token;
            } else LocalStorage.remove('user-token');

            resolve(res);
          })
          .catch((err) => {
            LocalStorage.remove('user-token');
            reject(err);
          });
      });
    },
    login(userData: { email: string; password: string; session: boolean }) {
      return new Promise((resolve, reject) => {
        UserService.userLogin(userData)
          .then((res) => {
            if (res.status._200_) {
              LocalStorage.set('user-token', res.data.token);

              this.token = res.data.token;
            } else LocalStorage.remove('user-token');

            resolve(res);
          })
          .catch((err) => {
            LocalStorage.remove('user-token');
            reject(err);
          });
      });
    },
    logout() {
      return new Promise((resolve) => {
        this.token = null;
        this.user = null;
        LocalStorage.remove('user-token');
        resolve(true);
      });
    },
    checkToken() {
      return (this.token = LocalStorage.getItem('user-token'));
    },
    parseToken(token = null) {
      if (!this.token || !token) return;

      if (!this.isJWT(this.token)) {
        console.error('Invalid JWT token format');
        LocalStorage.remove('user-token');
        window.location.href = '/login-or-register';
        return;
      }

      const base64Url = this.token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );

      this.user = ref(JSON.parse(jsonPayload));
    },
    isJWT(token) {
      if (typeof token !== 'string') return false;

      const parts = token.split('.');
      if (parts.length !== 3) return false;

      // Her parçanın Base64URL olup olmadığını kontrol et
      const base64urlRegex = /^[A-Za-z0-9_-]+$/;

      return parts.every((part) => base64urlRegex.test(part));
    },
  },
});
